// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BuildEditorController from "./build_editor_controller"
application.register("build-editor", BuildEditorController)

import BuildSkillOrderController from "./build_skill_order_controller"
application.register("build-skill-order", BuildSkillOrderController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import HealthChartController from "./health_chart_controller"
application.register("health-chart", HealthChartController)

import MatchBuildsController from "./match_builds_controller"
application.register("match-builds", MatchBuildsController)

import ProfessionNavController from "./profession_nav_controller"
application.register("profession-nav", ProfessionNavController)

import SearchDialogController from "./search_dialog_controller"
application.register("search-dialog", SearchDialogController)

import SkillPickerController from "./skill_picker_controller"
application.register("skill-picker", SkillPickerController)

import TemplateCodePopoverController from "./template_code_popover_controller"
application.register("template-code-popover", TemplateCodePopoverController)

import TemplateCodePreviewController from "./template_code_preview_controller"
application.register("template-code-preview", TemplateCodePreviewController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import VariantTabsController from "./variant_tabs_controller"
application.register("variant-tabs", VariantTabsController)
